import { Box } from '@mui/material';
import TaskList from '../../ui/ActivityCenterTasks/TaskList';

const Content = ({ tasks }) => (
  <Box sx={{
    maxHeight: 350,
    overflow: 'auto',
    p: 1,
  }}
  >
    <TaskList tasks={tasks} />
  </Box>
);

export default Content;
